import { yupResolver } from '@hookform/resolvers/yup';
import React from 'react';
import { useForm } from 'react-hook-form';

import { SuccessMessage } from '@eika/attention-message';
import { StandardButton } from '@eika/button';
import { ExpandableInput } from '@eika/expandable-input';
import { IconTypes } from '@eika/icon';

import { FormTypeFeedback } from '../../actions';
import { DispatchWithState, StringKeyValue } from '../../actions/types';
import { LoaderReducer } from '../../reducers/loader';
import { feedbackSchema } from '../../validation/loanApplicationSchema';

interface Props {
    sendFeedback: (form: FormTypeFeedback) => DispatchWithState;
    text: StringKeyValue;
    loader: LoaderReducer;
}

const FeedbackForm = ({ loader, sendFeedback, text }: Props): JSX.Element => {
    const { feedbackTitle, feedbackResponse, feedbackLabel, feedbackPlaceholder, feedbackButton } = text;

    const {
        handleSubmit,
        register,
        formState: { errors },
    } = useForm<FormTypeFeedback>({
        resolver: yupResolver(feedbackSchema),
        mode: 'onBlur',
    });

    return (
        <div className="feedback">
            {loader.hasSentFeedback ? (
                <div className="feedback__success">
                    <SuccessMessage text={feedbackResponse} icon={IconTypes.CHECKMARK_LISTE_24} />
                </div>
            ) : (
                <form
                    autoComplete="off"
                    onSubmit={handleSubmit((form) => {
                        sendFeedback(form);
                    })}
                >
                    {feedbackTitle && <h4>{feedbackTitle}</h4>}

                    <div className="feedback__message custom-form-group">
                        <label htmlFor="feedback">{feedbackLabel}</label>
                        <ExpandableInput
                            {...register('feedbackMessage')}
                            id="feedback"
                            placeholder={feedbackPlaceholder}
                            error={errors?.feedbackMessage?.message || ''}
                        />
                    </div>

                    <div className="feedback__submit">
                        <StandardButton type="submit">{feedbackButton}</StandardButton>
                    </div>
                </form>
            )}
        </div>
    );
};

export default FeedbackForm;
